import React from 'react';
import './CreateBenchmarkByNaturalLanguage.css';
import Card from 'react-bootstrap/Card';



function CreateBenchmarkByNaturalLanguage() {
  return (
    <div>Create Benchmark By Natural Language
     
    </div>
  )
}

export default CreateBenchmarkByNaturalLanguage